import { queryOptions, useQuery } from '@tanstack/react-query';
import { FAST_ID_REGEX, getBalanceEstimate, searchUsers } from '@/services/api/users';

export const USER_SEARCH_QUERY_KEY = ['users', 'search'] as const;
export const USER_BALANCE_ESTIMATE_QUERY_KEY = ['users', 'balance-estimate'] as const;

// Search is manual: pass '' until the user submits — the query stays disabled.
export const userSearchQueryOptions = (q: string) =>
  queryOptions({
    queryKey: [...USER_SEARCH_QUERY_KEY, q],
    queryFn: () => searchUsers(q),
    enabled: q.trim() !== '',
  });

export const useUserSearch = (q: string) => useQuery(userSearchQueryOptions(q));

// Disabled until a fastId is known AND numeric — the endpoint rejects anything else.
export const userBalanceEstimateQueryOptions = (fastId: string | null) =>
  queryOptions({
    queryKey: [...USER_BALANCE_ESTIMATE_QUERY_KEY, fastId],
    queryFn: () => {
      if (!fastId) throw new Error('fastId is required');
      return getBalanceEstimate(fastId);
    },
    enabled: fastId !== null && FAST_ID_REGEX.test(fastId),
  });

export const useUserBalanceEstimate = (fastId: string | null) => useQuery(userBalanceEstimateQueryOptions(fastId));
